<template>
	<div v-if="isOpen && member" class="team-modal-overlay" @click.self="$emit('close')">
		<div class="team-modal" role="dialog" aria-modal="true" :aria-label="member.name">
			<button
				class="team-modal-close"
				type="button"
				aria-label="Close"
				@click="$emit('close')"
			>
				<i class="bi bi-x-lg"></i>
			</button>

			<div class="modal-content">
				<div v-if="!member.is_placeholder" class="modal-image">
					<img :src="member.profile_image" :alt="member.name" />
				</div>

				<div class="modal-info">
					<h3 class="team-name">{{ member.name }}</h3>
					<p v-if="member.title" class="team-title">{{ member.title }}</p>
					<p v-if="member.location" class="team-location">
						<i class="bi bi-geo-alt"></i> {{ member.location }}
					</p>
					<a
						v-if="member.email"
						:href="`mailto:${member.email}`"
						class="btn btn-outline-primary contact-btn"
					>
						Contact
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TeamModal',
	props: {
		member: {
			type: Object,
			default: null,
		},
		isOpen: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['close'],
};
</script>
